import { SUCCESS, FAIL, GET_TILES } from "../action_types";

const STATE_INIT = {
  isLoading: false,
  docketDetails: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_TILES:
      return { ...state, isLoading: true };
    case `${GET_TILES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        docketDetails: payload,
      };
    case `${GET_TILES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
        return state;
  }
};


